export const hintList: {
  title: string;
  description: string;
}[] = [
  {
    title: '',
    description: 'Камера на уровне глаз, голова и взгляд направлены в камеру',
  },
  {
    title: '',
    description: 'Дневной свет. Лучший вариант - встать напротив окна',
  },
  {
    title: '',
    description: 'Волосы не закрывают лицо',
  },
  {
    title: '',
    description: 'Плечи и голова в кадре',
  },
  {
    title: '',
    description: 'Фото без фильтров / обработки',
  },
];
